// AUTO-GENERATED SQL Builder (V40 Final) for Offering
import { 
  SqlField, 
  SqlExp, 
  SqlExpChain, 
  SqlFn, 
  SqlLiteral, 
  SqlSubQuery, 
  SqlApplyColumn, 
  SqlNavHybrid, 
  createNavHybrid 
} from '../utils/sql-core';
import { SqlAst } from '../utils/sql-ast';

export class OfferingSql {
  private ast = new SqlAst('Offering', 'offering');
  public readonly main: any = {};

  public guid: SqlField;
  public vendorId: SqlField;
  public serviceCategoryId: SqlField;
  public name: SqlField;
  public description: SqlField;
  public basePrice: SqlField;
  public pricingUnit: SqlField;
  public minPax: SqlField;
  public maxPax: SqlField;
  public status: SqlField;
  public maxTables: SqlField;
  public hallMode: SqlField;
  public showFacilities: SqlField;
  public pricingMode: SqlField;
  public createdByUser: SqlNavHybrid;
  public serviceCategory: SqlNavHybrid;
  public updatedByUser: SqlNavHybrid;
  public vendor: SqlNavHybrid;
  public blockedDateList: SqlNavHybrid;
  public bookingList: SqlNavHybrid;
  public bookingChangeProposalList: SqlNavHybrid;
  public bookingPackageByBundleOfferingList: SqlNavHybrid;
  public bookingPackageByOfferingList: SqlNavHybrid;
  public bookingPartnerChangeList: SqlNavHybrid;
  public menuCourseList: SqlNavHybrid;
  public offeringAddonList: SqlNavHybrid;
  public offeringFacilityList: SqlNavHybrid;
  public offeringIncludeList: SqlNavHybrid;
  public offeringItemList: SqlNavHybrid;
  public offeringMilestoneList: SqlNavHybrid;
  public offeringPackageList: SqlNavHybrid;
  public offeringPortfolioList: SqlNavHybrid;
  public offeringSessionList: SqlNavHybrid;
  public offeringSlotList: SqlNavHybrid;
  public packageItemList: SqlNavHybrid;
  public resaleList: SqlNavHybrid;
  public resaleTermList: SqlNavHybrid;
  public reviewList: SqlNavHybrid;
  public slotOptionList: SqlNavHybrid;
  public waitlistList: SqlNavHybrid;
  public id: SqlField;
  public isDeleted: SqlField;
  public createdBy: SqlField;
  public createdDate: SqlField;
  public updatedBy: SqlField;
  public updatedDate: SqlField;

  constructor() {
    this.guid = new SqlField('offering', 'guid', '', 'id', 'offering_guid');
    this.vendorId = new SqlField('offering', 'vendorId', 'vendor', 'id', 'offering_vendor');
    this.serviceCategoryId = new SqlField('offering', 'serviceCategoryId', 'serviceCategory', 'id', 'offering_serviceCategory');
    this.name = new SqlField('offering', 'name', '', 'id', 'offering_name');
    this.description = new SqlField('offering', 'description', '', 'id', 'offering_description');
    this.basePrice = new SqlField('offering', 'basePrice', '', 'id', 'offering_basePrice');
    this.pricingUnit = new SqlField('offering', 'pricingUnit', '', 'id', 'offering_pricingUnit');
    this.minPax = new SqlField('offering', 'minPax', '', 'id', 'offering_minPax');
    this.maxPax = new SqlField('offering', 'maxPax', '', 'id', 'offering_maxPax');
    this.status = new SqlField('offering', 'status', '', 'id', 'offering_status');
    this.maxTables = new SqlField('offering', 'maxTables', '', 'id', 'offering_maxTables');
    this.hallMode = new SqlField('offering', 'hallMode', '', 'id', 'offering_hallMode');
    this.showFacilities = new SqlField('offering', 'showFacilities', '', 'id', 'offering_showFacilities');
    this.pricingMode = new SqlField('offering', 'pricingMode', '', 'id', 'offering_pricingMode');
    this.createdByUser = createNavHybrid('offering', 'offering_createdByUser', 'User');
    this.serviceCategory = createNavHybrid('offering', 'offering_serviceCategory', 'ServiceCategory');
    this.updatedByUser = createNavHybrid('offering', 'offering_updatedByUser', 'User');
    this.vendor = createNavHybrid('offering', 'offering_vendor', 'Vendor');
    this.blockedDateList = createNavHybrid('offering', 'offering_blockedDateList', 'BlockedDate');
    this.bookingList = createNavHybrid('offering', 'offering_bookingList', 'Booking');
    this.bookingChangeProposalList = createNavHybrid('offering', 'offering_bookingChangeProposalList', 'BookingChangeProposal');
    this.bookingPackageByBundleOfferingList = createNavHybrid('offering', 'offering_bookingPackageByBundleOfferingList', 'BookingPackage');
    this.bookingPackageByOfferingList = createNavHybrid('offering', 'offering_bookingPackageByOfferingList', 'BookingPackage');
    this.bookingPartnerChangeList = createNavHybrid('offering', 'offering_bookingPartnerChangeList', 'BookingPartnerChange');
    this.menuCourseList = createNavHybrid('offering', 'offering_menuCourseList', 'MenuCourse');
    this.offeringAddonList = createNavHybrid('offering', 'offering_offeringAddonList', 'OfferingAddon');
    this.offeringFacilityList = createNavHybrid('offering', 'offering_offeringFacilityList', 'OfferingFacility');
    this.offeringIncludeList = createNavHybrid('offering', 'offering_offeringIncludeList', 'OfferingInclude');
    this.offeringItemList = createNavHybrid('offering', 'offering_offeringItemList', 'OfferingItem');
    this.offeringMilestoneList = createNavHybrid('offering', 'offering_offeringMilestoneList', 'OfferingMilestone');
    this.offeringPackageList = createNavHybrid('offering', 'offering_offeringPackageList', 'OfferingPackage');
    this.offeringPortfolioList = createNavHybrid('offering', 'offering_offeringPortfolioList', 'OfferingPortfolio');
    this.offeringSessionList = createNavHybrid('offering', 'offering_offeringSessionList', 'OfferingSession');
    this.offeringSlotList = createNavHybrid('offering', 'offering_offeringSlotList', 'OfferingSlot');
    this.packageItemList = createNavHybrid('offering', 'offering_packageItemList', 'PackageItem');
    this.resaleList = createNavHybrid('offering', 'offering_resaleList', 'Resale');
    this.resaleTermList = createNavHybrid('offering', 'offering_resaleTermList', 'ResaleTerm');
    this.reviewList = createNavHybrid('offering', 'offering_reviewList', 'Review');
    this.slotOptionList = createNavHybrid('offering', 'offering_slotOptionList', 'SlotOption');
    this.waitlistList = createNavHybrid('offering', 'offering_waitlistList', 'Waitlist');
    this.id = new SqlField('offering', 'id', '', 'id', 'offering_id');
    this.isDeleted = new SqlField('offering', 'isDeleted', '', 'id', 'offering_isDeleted');
    this.createdBy = new SqlField('offering', 'createdBy', '', 'id', 'offering_createdBy');
    this.createdDate = new SqlField('offering', 'createdDate', '', 'id', 'offering_createdDate');
    this.updatedBy = new SqlField('offering', 'updatedBy', '', 'id', 'offering_updatedBy');
    this.updatedDate = new SqlField('offering', 'updatedDate', '', 'id', 'offering_updatedDate');

    for (const k of Object.keys(this)) {
      const v = (this as any)[k];
      if (v instanceof SqlField) this.main[k] = v;
    }
  }

  // SELECT
  select(fn:(x:OfferingSql)=>any) {
    this.ast.addSelectObject(fn(this));
    return this;
  }

  // WHERE
  where(fn:(x:OfferingSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  and(fn:(x:OfferingSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  or(fn:(x:OfferingSql)=>SqlExp | SqlExpChain) {
    this.ast.addOr(fn(this));
    return this;
  }

  // JOIN
  join(fn:(x:OfferingSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f);
    return this;
  }
  leftJoin(fn:(x:OfferingSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'LEFT');
    return this;
  }
  rightJoin(fn:(x:OfferingSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'RIGHT');
    return this;
  }

  // AND JOIN
  andJoin(fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    const last = this.ast.joins[this.ast.joins.length - 1];
    if (!last) throw new Error('andJoin() before join()');

    const left = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(this.ast.alias, prop)
    });
    const right = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(last.alias, prop)
    });

    const exp = (this.ast as any).compileExp(fn(left, right));

    if (typeof last.on === 'string') {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[
          { column:last.on, operator:'', value:null, isTrusted:true, subFilters:[] },
          exp
        ]
      };
    }
    else if (last.on.logic === 'And') {
      last.on.subFilters.push(exp);
    }
    else {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[ last.on, exp ]
      };
    }

    return this;
  }

  // CTE
  with(name:string, fn:(c:any)=>any) {
    this.ast.with(name, fn);
    return this;
  }
  withRecursive(name:string, fn:(c:any)=>any) {
    this.ast.withRecursive(name, fn);
    return this;
  }

  // CTE JOIN
  joinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.joinCTE(name, alias, fn);
    return this;
  }
  fullJoinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.fullJoinCTE(name, alias, fn);
    return this;
  }

  // SUBQUERY
  subQuery(fn:(b:any)=>any) {
    return new SqlSubQuery(fn);
  }

  // APPLY
  apply(name:string, fn:(b:any)=>any) {
    this.ast.apply(name, fn);
    return this;
  }
  applyColumn(name:string, fn:(b:any)=>SqlField) {
    return this.ast.applyColumn(name, fn);
  }
  crossApply(app:any) {
    this.ast.crossApply(app);
    return this;
  }

  // GROUP BY
  groupBy(fn:(x:OfferingSql)=>SqlField[]) {
    this.ast.addGroup(fn(this));
    return this;
  }

  // HAVING
  having(fn:(x:OfferingSql)=>SqlExp | SqlExpChain) {
    this.ast.addHaving(fn(this));
    return this;
  }

  // ORDER
  orderBy(fn:(x:OfferingSql)=>any[]) {
    this.ast.addOrder(fn(this));
    return this;
  }

  // UNION
  union(fn:(q:any)=>any) {
    this.ast.union(fn);
    return this;
  }
  unionAll(fn:(q:any)=>any) {
    this.ast.unionAll(fn);
    return this;
  }

  limit(n:number) { this.ast.take = n; return this; }
  offset(n:number) { this.ast.skip = n; return this; }

  build() {
    return this.ast.toQueryDescriptor();
  }
}
